import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

export type GtwSnackbarPanelClass = 
  | 'gtw-snackbar--green'
  | 'gtw-snackbar--red' 
  | 'gtw-snackbar--yellow'
  | 'gtw-snackbar--orange'
  | '';

export interface GtwSnackbarData {
  message: string;
  closable?: boolean;
}

@Component({
    selector: 'gtw-custom-snackbar',
    templateUrl: './gtw-custom-snackbar.component.html',
    styleUrls: ['./gtw-custom-snackbar.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class GtwCustomSnackbarComponent {

  constructor(
    public snackBarRef: MatSnackBarRef<GtwCustomSnackbarComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: GtwSnackbarData
  ) {}

  closeSnackbar(): void {
    this.snackBarRef.dismiss();
  }
}
